/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as CliAuthRouteImport } from './routes/cli-auth/route'
import { Route as UnauthorizedLayoutRouteImport } from './routes/_unauthorized-layout/route'
import { Route as AuthorizedLayoutRouteImport } from './routes/_authorized-layout/route'
import { Route as UnauthorizedLayoutLoginRouteImport } from './routes/_unauthorized-layout/login/route'
import { Route as UnauthorizedLayoutGoodbyeRouteImport } from './routes/_unauthorized-layout/goodbye/route'
import { Route as AuthorizedLayoutSearchLayoutRouteImport } from './routes/_authorized-layout/_search-layout/route'
import { Route as AuthorizedLayoutAppLayoutRouteImport } from './routes/_authorized-layout/_app-layout/route'
import { Route as AuthorizedLayoutAppLayoutDictionaryEditWordIdImport } from './routes/_authorized-layout/_app-layout/dictionary/edit/$wordId'

// Create Virtual Routes

const AuthorizedLayoutSearchLayoutIndexLazyImport = createFileRoute(
  '/_authorized-layout/_search-layout/',
)()
const AuthorizedLayoutAppLayoutSettingsRouteLazyImport = createFileRoute(
  '/_authorized-layout/_app-layout/settings',
)()
const AuthorizedLayoutAppLayoutProgressRouteLazyImport = createFileRoute(
  '/_authorized-layout/_app-layout/progress',
)()
const AuthorizedLayoutAppLayoutDecksRouteLazyImport = createFileRoute(
  '/_authorized-layout/_app-layout/decks',
)()
const AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyImport = createFileRoute(
  '/_authorized-layout/_app-layout/checkout-success',
)()
const AuthorizedLayoutAppLayoutDictionaryAddRouteLazyImport = createFileRoute(
  '/_authorized-layout/_app-layout/dictionary/add',
)()

// Create/Update Routes

const CliAuthRouteRoute = CliAuthRouteImport.update({
  id: '/cli-auth',
  path: '/cli-auth',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/cli-auth/route.lazy').then((d) => d.Route),
)

const UnauthorizedLayoutRouteRoute = UnauthorizedLayoutRouteImport.update({
  id: '/_unauthorized-layout',
  getParentRoute: () => rootRoute,
} as any)

const AuthorizedLayoutRouteRoute = AuthorizedLayoutRouteImport.update({
  id: '/_authorized-layout',
  getParentRoute: () => rootRoute,
} as any)

const UnauthorizedLayoutLoginRouteRoute =
  UnauthorizedLayoutLoginRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: () => UnauthorizedLayoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_unauthorized-layout/login/route.lazy').then(
      (d) => d.Route,
    ),
  )

const UnauthorizedLayoutGoodbyeRouteRoute =
  UnauthorizedLayoutGoodbyeRouteImport.update({
    id: '/goodbye',
    path: '/goodbye',
    getParentRoute: () => UnauthorizedLayoutRouteRoute,
  } as any)

const AuthorizedLayoutSearchLayoutRouteRoute =
  AuthorizedLayoutSearchLayoutRouteImport.update({
    id: '/_search-layout',
    getParentRoute: () => AuthorizedLayoutRouteRoute,
  } as any)

const AuthorizedLayoutAppLayoutRouteRoute =
  AuthorizedLayoutAppLayoutRouteImport.update({
    id: '/_app-layout',
    getParentRoute: () => AuthorizedLayoutRouteRoute,
  } as any)

const AuthorizedLayoutSearchLayoutIndexLazyRoute =
  AuthorizedLayoutSearchLayoutIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedLayoutSearchLayoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authorized-layout/_search-layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthorizedLayoutAppLayoutSettingsRouteLazyRoute =
  AuthorizedLayoutAppLayoutSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthorizedLayoutAppLayoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authorized-layout/_app-layout/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthorizedLayoutAppLayoutProgressRouteLazyRoute =
  AuthorizedLayoutAppLayoutProgressRouteLazyImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => AuthorizedLayoutAppLayoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authorized-layout/_app-layout/progress/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthorizedLayoutAppLayoutDecksRouteLazyRoute =
  AuthorizedLayoutAppLayoutDecksRouteLazyImport.update({
    id: '/decks',
    path: '/decks',
    getParentRoute: () => AuthorizedLayoutAppLayoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authorized-layout/_app-layout/decks/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute =
  AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyImport.update({
    id: '/checkout-success',
    path: '/checkout-success',
    getParentRoute: () => AuthorizedLayoutAppLayoutRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authorized-layout/_app-layout/checkout-success/route.lazy'
    ).then((d) => d.Route),
  )

const AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute =
  AuthorizedLayoutAppLayoutDictionaryAddRouteLazyImport.update({
    id: '/dictionary/add',
    path: '/dictionary/add',
    getParentRoute: () => AuthorizedLayoutAppLayoutRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authorized-layout/_app-layout/dictionary/add/route.lazy'
    ).then((d) => d.Route),
  )

const AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute =
  AuthorizedLayoutAppLayoutDictionaryEditWordIdImport.update({
    id: '/dictionary/edit/$wordId',
    path: '/dictionary/edit/$wordId',
    getParentRoute: () => AuthorizedLayoutAppLayoutRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authorized-layout': {
      id: '/_authorized-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthorizedLayoutRouteImport
      parentRoute: typeof rootRoute
    }
    '/_unauthorized-layout': {
      id: '/_unauthorized-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthorizedLayoutRouteImport
      parentRoute: typeof rootRoute
    }
    '/cli-auth': {
      id: '/cli-auth'
      path: '/cli-auth'
      fullPath: '/cli-auth'
      preLoaderRoute: typeof CliAuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authorized-layout/_app-layout': {
      id: '/_authorized-layout/_app-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthorizedLayoutAppLayoutRouteImport
      parentRoute: typeof AuthorizedLayoutRouteImport
    }
    '/_authorized-layout/_search-layout': {
      id: '/_authorized-layout/_search-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthorizedLayoutSearchLayoutRouteImport
      parentRoute: typeof AuthorizedLayoutRouteImport
    }
    '/_unauthorized-layout/goodbye': {
      id: '/_unauthorized-layout/goodbye'
      path: '/goodbye'
      fullPath: '/goodbye'
      preLoaderRoute: typeof UnauthorizedLayoutGoodbyeRouteImport
      parentRoute: typeof UnauthorizedLayoutRouteImport
    }
    '/_unauthorized-layout/login': {
      id: '/_unauthorized-layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthorizedLayoutLoginRouteImport
      parentRoute: typeof UnauthorizedLayoutRouteImport
    }
    '/_authorized-layout/_app-layout/checkout-success': {
      id: '/_authorized-layout/_app-layout/checkout-success'
      path: '/checkout-success'
      fullPath: '/checkout-success'
      preLoaderRoute: typeof AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyImport
      parentRoute: typeof AuthorizedLayoutAppLayoutRouteImport
    }
    '/_authorized-layout/_app-layout/decks': {
      id: '/_authorized-layout/_app-layout/decks'
      path: '/decks'
      fullPath: '/decks'
      preLoaderRoute: typeof AuthorizedLayoutAppLayoutDecksRouteLazyImport
      parentRoute: typeof AuthorizedLayoutAppLayoutRouteImport
    }
    '/_authorized-layout/_app-layout/progress': {
      id: '/_authorized-layout/_app-layout/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof AuthorizedLayoutAppLayoutProgressRouteLazyImport
      parentRoute: typeof AuthorizedLayoutAppLayoutRouteImport
    }
    '/_authorized-layout/_app-layout/settings': {
      id: '/_authorized-layout/_app-layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthorizedLayoutAppLayoutSettingsRouteLazyImport
      parentRoute: typeof AuthorizedLayoutAppLayoutRouteImport
    }
    '/_authorized-layout/_search-layout/': {
      id: '/_authorized-layout/_search-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthorizedLayoutSearchLayoutIndexLazyImport
      parentRoute: typeof AuthorizedLayoutSearchLayoutRouteImport
    }
    '/_authorized-layout/_app-layout/dictionary/add': {
      id: '/_authorized-layout/_app-layout/dictionary/add'
      path: '/dictionary/add'
      fullPath: '/dictionary/add'
      preLoaderRoute: typeof AuthorizedLayoutAppLayoutDictionaryAddRouteLazyImport
      parentRoute: typeof AuthorizedLayoutAppLayoutRouteImport
    }
    '/_authorized-layout/_app-layout/dictionary/edit/$wordId': {
      id: '/_authorized-layout/_app-layout/dictionary/edit/$wordId'
      path: '/dictionary/edit/$wordId'
      fullPath: '/dictionary/edit/$wordId'
      preLoaderRoute: typeof AuthorizedLayoutAppLayoutDictionaryEditWordIdImport
      parentRoute: typeof AuthorizedLayoutAppLayoutRouteImport
    }
  }
}

// Create and export the route tree

interface AuthorizedLayoutAppLayoutRouteRouteChildren {
  AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute: typeof AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute
  AuthorizedLayoutAppLayoutDecksRouteLazyRoute: typeof AuthorizedLayoutAppLayoutDecksRouteLazyRoute
  AuthorizedLayoutAppLayoutProgressRouteLazyRoute: typeof AuthorizedLayoutAppLayoutProgressRouteLazyRoute
  AuthorizedLayoutAppLayoutSettingsRouteLazyRoute: typeof AuthorizedLayoutAppLayoutSettingsRouteLazyRoute
  AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute: typeof AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute
  AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute: typeof AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute
}

const AuthorizedLayoutAppLayoutRouteRouteChildren: AuthorizedLayoutAppLayoutRouteRouteChildren =
  {
    AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute:
      AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute,
    AuthorizedLayoutAppLayoutDecksRouteLazyRoute:
      AuthorizedLayoutAppLayoutDecksRouteLazyRoute,
    AuthorizedLayoutAppLayoutProgressRouteLazyRoute:
      AuthorizedLayoutAppLayoutProgressRouteLazyRoute,
    AuthorizedLayoutAppLayoutSettingsRouteLazyRoute:
      AuthorizedLayoutAppLayoutSettingsRouteLazyRoute,
    AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute:
      AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute,
    AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute:
      AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute,
  }

const AuthorizedLayoutAppLayoutRouteRouteWithChildren =
  AuthorizedLayoutAppLayoutRouteRoute._addFileChildren(
    AuthorizedLayoutAppLayoutRouteRouteChildren,
  )

interface AuthorizedLayoutSearchLayoutRouteRouteChildren {
  AuthorizedLayoutSearchLayoutIndexLazyRoute: typeof AuthorizedLayoutSearchLayoutIndexLazyRoute
}

const AuthorizedLayoutSearchLayoutRouteRouteChildren: AuthorizedLayoutSearchLayoutRouteRouteChildren =
  {
    AuthorizedLayoutSearchLayoutIndexLazyRoute:
      AuthorizedLayoutSearchLayoutIndexLazyRoute,
  }

const AuthorizedLayoutSearchLayoutRouteRouteWithChildren =
  AuthorizedLayoutSearchLayoutRouteRoute._addFileChildren(
    AuthorizedLayoutSearchLayoutRouteRouteChildren,
  )

interface AuthorizedLayoutRouteRouteChildren {
  AuthorizedLayoutAppLayoutRouteRoute: typeof AuthorizedLayoutAppLayoutRouteRouteWithChildren
  AuthorizedLayoutSearchLayoutRouteRoute: typeof AuthorizedLayoutSearchLayoutRouteRouteWithChildren
}

const AuthorizedLayoutRouteRouteChildren: AuthorizedLayoutRouteRouteChildren = {
  AuthorizedLayoutAppLayoutRouteRoute:
    AuthorizedLayoutAppLayoutRouteRouteWithChildren,
  AuthorizedLayoutSearchLayoutRouteRoute:
    AuthorizedLayoutSearchLayoutRouteRouteWithChildren,
}

const AuthorizedLayoutRouteRouteWithChildren =
  AuthorizedLayoutRouteRoute._addFileChildren(
    AuthorizedLayoutRouteRouteChildren,
  )

interface UnauthorizedLayoutRouteRouteChildren {
  UnauthorizedLayoutGoodbyeRouteRoute: typeof UnauthorizedLayoutGoodbyeRouteRoute
  UnauthorizedLayoutLoginRouteRoute: typeof UnauthorizedLayoutLoginRouteRoute
}

const UnauthorizedLayoutRouteRouteChildren: UnauthorizedLayoutRouteRouteChildren =
  {
    UnauthorizedLayoutGoodbyeRouteRoute: UnauthorizedLayoutGoodbyeRouteRoute,
    UnauthorizedLayoutLoginRouteRoute: UnauthorizedLayoutLoginRouteRoute,
  }

const UnauthorizedLayoutRouteRouteWithChildren =
  UnauthorizedLayoutRouteRoute._addFileChildren(
    UnauthorizedLayoutRouteRouteChildren,
  )

export interface FileRoutesByFullPath {
  '': typeof AuthorizedLayoutSearchLayoutRouteRouteWithChildren
  '/cli-auth': typeof CliAuthRouteRoute
  '/goodbye': typeof UnauthorizedLayoutGoodbyeRouteRoute
  '/login': typeof UnauthorizedLayoutLoginRouteRoute
  '/checkout-success': typeof AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute
  '/decks': typeof AuthorizedLayoutAppLayoutDecksRouteLazyRoute
  '/progress': typeof AuthorizedLayoutAppLayoutProgressRouteLazyRoute
  '/settings': typeof AuthorizedLayoutAppLayoutSettingsRouteLazyRoute
  '/': typeof AuthorizedLayoutSearchLayoutIndexLazyRoute
  '/dictionary/add': typeof AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute
  '/dictionary/edit/$wordId': typeof AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute
}

export interface FileRoutesByTo {
  '': typeof AuthorizedLayoutAppLayoutRouteRouteWithChildren
  '/cli-auth': typeof CliAuthRouteRoute
  '/goodbye': typeof UnauthorizedLayoutGoodbyeRouteRoute
  '/login': typeof UnauthorizedLayoutLoginRouteRoute
  '/checkout-success': typeof AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute
  '/decks': typeof AuthorizedLayoutAppLayoutDecksRouteLazyRoute
  '/progress': typeof AuthorizedLayoutAppLayoutProgressRouteLazyRoute
  '/settings': typeof AuthorizedLayoutAppLayoutSettingsRouteLazyRoute
  '/': typeof AuthorizedLayoutSearchLayoutIndexLazyRoute
  '/dictionary/add': typeof AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute
  '/dictionary/edit/$wordId': typeof AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authorized-layout': typeof AuthorizedLayoutRouteRouteWithChildren
  '/_unauthorized-layout': typeof UnauthorizedLayoutRouteRouteWithChildren
  '/cli-auth': typeof CliAuthRouteRoute
  '/_authorized-layout/_app-layout': typeof AuthorizedLayoutAppLayoutRouteRouteWithChildren
  '/_authorized-layout/_search-layout': typeof AuthorizedLayoutSearchLayoutRouteRouteWithChildren
  '/_unauthorized-layout/goodbye': typeof UnauthorizedLayoutGoodbyeRouteRoute
  '/_unauthorized-layout/login': typeof UnauthorizedLayoutLoginRouteRoute
  '/_authorized-layout/_app-layout/checkout-success': typeof AuthorizedLayoutAppLayoutCheckoutSuccessRouteLazyRoute
  '/_authorized-layout/_app-layout/decks': typeof AuthorizedLayoutAppLayoutDecksRouteLazyRoute
  '/_authorized-layout/_app-layout/progress': typeof AuthorizedLayoutAppLayoutProgressRouteLazyRoute
  '/_authorized-layout/_app-layout/settings': typeof AuthorizedLayoutAppLayoutSettingsRouteLazyRoute
  '/_authorized-layout/_search-layout/': typeof AuthorizedLayoutSearchLayoutIndexLazyRoute
  '/_authorized-layout/_app-layout/dictionary/add': typeof AuthorizedLayoutAppLayoutDictionaryAddRouteLazyRoute
  '/_authorized-layout/_app-layout/dictionary/edit/$wordId': typeof AuthorizedLayoutAppLayoutDictionaryEditWordIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/cli-auth'
    | '/goodbye'
    | '/login'
    | '/checkout-success'
    | '/decks'
    | '/progress'
    | '/settings'
    | '/'
    | '/dictionary/add'
    | '/dictionary/edit/$wordId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/cli-auth'
    | '/goodbye'
    | '/login'
    | '/checkout-success'
    | '/decks'
    | '/progress'
    | '/settings'
    | '/'
    | '/dictionary/add'
    | '/dictionary/edit/$wordId'
  id:
    | '__root__'
    | '/_authorized-layout'
    | '/_unauthorized-layout'
    | '/cli-auth'
    | '/_authorized-layout/_app-layout'
    | '/_authorized-layout/_search-layout'
    | '/_unauthorized-layout/goodbye'
    | '/_unauthorized-layout/login'
    | '/_authorized-layout/_app-layout/checkout-success'
    | '/_authorized-layout/_app-layout/decks'
    | '/_authorized-layout/_app-layout/progress'
    | '/_authorized-layout/_app-layout/settings'
    | '/_authorized-layout/_search-layout/'
    | '/_authorized-layout/_app-layout/dictionary/add'
    | '/_authorized-layout/_app-layout/dictionary/edit/$wordId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthorizedLayoutRouteRoute: typeof AuthorizedLayoutRouteRouteWithChildren
  UnauthorizedLayoutRouteRoute: typeof UnauthorizedLayoutRouteRouteWithChildren
  CliAuthRouteRoute: typeof CliAuthRouteRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthorizedLayoutRouteRoute: AuthorizedLayoutRouteRouteWithChildren,
  UnauthorizedLayoutRouteRoute: UnauthorizedLayoutRouteRouteWithChildren,
  CliAuthRouteRoute: CliAuthRouteRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authorized-layout",
        "/_unauthorized-layout",
        "/cli-auth"
      ]
    },
    "/_authorized-layout": {
      "filePath": "_authorized-layout/route.tsx",
      "children": [
        "/_authorized-layout/_app-layout",
        "/_authorized-layout/_search-layout"
      ]
    },
    "/_unauthorized-layout": {
      "filePath": "_unauthorized-layout/route.tsx",
      "children": [
        "/_unauthorized-layout/goodbye",
        "/_unauthorized-layout/login"
      ]
    },
    "/cli-auth": {
      "filePath": "cli-auth/route.tsx"
    },
    "/_authorized-layout/_app-layout": {
      "filePath": "_authorized-layout/_app-layout/route.tsx",
      "parent": "/_authorized-layout",
      "children": [
        "/_authorized-layout/_app-layout/checkout-success",
        "/_authorized-layout/_app-layout/decks",
        "/_authorized-layout/_app-layout/progress",
        "/_authorized-layout/_app-layout/settings",
        "/_authorized-layout/_app-layout/dictionary/add",
        "/_authorized-layout/_app-layout/dictionary/edit/$wordId"
      ]
    },
    "/_authorized-layout/_search-layout": {
      "filePath": "_authorized-layout/_search-layout/route.tsx",
      "parent": "/_authorized-layout",
      "children": [
        "/_authorized-layout/_search-layout/"
      ]
    },
    "/_unauthorized-layout/goodbye": {
      "filePath": "_unauthorized-layout/goodbye/route.tsx",
      "parent": "/_unauthorized-layout"
    },
    "/_unauthorized-layout/login": {
      "filePath": "_unauthorized-layout/login/route.tsx",
      "parent": "/_unauthorized-layout"
    },
    "/_authorized-layout/_app-layout/checkout-success": {
      "filePath": "_authorized-layout/_app-layout/checkout-success/route.lazy.tsx",
      "parent": "/_authorized-layout/_app-layout"
    },
    "/_authorized-layout/_app-layout/decks": {
      "filePath": "_authorized-layout/_app-layout/decks/route.lazy.tsx",
      "parent": "/_authorized-layout/_app-layout"
    },
    "/_authorized-layout/_app-layout/progress": {
      "filePath": "_authorized-layout/_app-layout/progress/route.lazy.tsx",
      "parent": "/_authorized-layout/_app-layout"
    },
    "/_authorized-layout/_app-layout/settings": {
      "filePath": "_authorized-layout/_app-layout/settings/route.lazy.tsx",
      "parent": "/_authorized-layout/_app-layout"
    },
    "/_authorized-layout/_search-layout/": {
      "filePath": "_authorized-layout/_search-layout/index.lazy.tsx",
      "parent": "/_authorized-layout/_search-layout"
    },
    "/_authorized-layout/_app-layout/dictionary/add": {
      "filePath": "_authorized-layout/_app-layout/dictionary/add/route.lazy.tsx",
      "parent": "/_authorized-layout/_app-layout"
    },
    "/_authorized-layout/_app-layout/dictionary/edit/$wordId": {
      "filePath": "_authorized-layout/_app-layout/dictionary/edit/$wordId.tsx",
      "parent": "/_authorized-layout/_app-layout"
    }
  }
}
ROUTE_MANIFEST_END */
